// Organization Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';
import { dedupedGet } from '../../utils/api/dedupedFetch';

export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAIL = 'GET_ORGANIZATIONS_FAIL';
export const GET_ORGANIZATIONS_RESET = 'GET_ORGANIZATIONS_RESET';

export const GET_ORGANIZATION_BY_ID = 'GET_ORGANIZATION_BY_ID';
export const GET_ORGANIZATION_BY_ID_SUCCESS = 'GET_ORGANIZATION_BY_ID_SUCCESS';
export const GET_ORGANIZATION_BY_ID_FAIL = 'GET_ORGANIZATION_BY_ID_FAIL';
export const GET_ORGANIZATION_BY_ID_RESET = 'GET_ORGANIZATION_BY_ID_RESET';

export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAIL = 'CREATE_ORGANIZATION_FAIL';
export const CREATE_ORGANIZATION_RESET = 'CREATE_ORGANIZATION_RESET';

export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAIL = 'UPDATE_ORGANIZATION_FAIL';
export const UPDATE_ORGANIZATION_RESET = 'UPDATE_ORGANIZATION_RESET';

export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_FAIL = 'DELETE_ORGANIZATION_FAIL';
export const DELETE_ORGANIZATION_RESET = 'DELETE_ORGANIZATION_RESET';

export const GET_ORGANIZATIONS_DROPDOWN = 'GET_ORGANIZATIONS_DROPDOWN';
export const GET_ORGANIZATIONS_DROPDOWN_SUCCESS = 'GET_ORGANIZATIONS_DROPDOWN_SUCCESS';
export const GET_ORGANIZATIONS_DROPDOWN_FAIL = 'GET_ORGANIZATIONS_DROPDOWN_FAIL';
export const GET_ORGANIZATIONS_DROPDOWN_RESET = 'GET_ORGANIZATIONS_DROPDOWN_RESET';

// Thunk Actions
export const getOrganizationsApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_ORGANIZATIONS });
		const paramKey = JSON.stringify(data || {});
		dedupedGet(`organizations:${paramKey}`, () =>
			axios.get(`${config.api.base_url}/organizations`, {
				params: data,
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_ORGANIZATIONS_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_ORGANIZATIONS_FAIL, response: error.response?.data || error.message }));
	};
};

export const getOrganizationByIdApi = (id) => {
	return (dispatch) => {
		dispatch({ type: GET_ORGANIZATION_BY_ID });
		dedupedGet(`organizationById:${id}`, () =>
			axios.get(`${config.api.base_url}/organizations/${id}`, {
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_ORGANIZATION_BY_ID_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_ORGANIZATION_BY_ID_FAIL, response: error.response?.data || error.message }));
	};
};

export const createOrganizationApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CREATE_ORGANIZATION });
		axios
			.post(`${config.api.base_url}/organizations`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createOrganizationData = response.data;
				dispatch({ type: CREATE_ORGANIZATION_SUCCESS, response: createOrganizationData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CREATE_ORGANIZATION_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const updateOrganizationApi = (id, data) => {
	return (dispatch) => {
		dispatch({ type: UPDATE_ORGANIZATION });
		axios
			.post(`${config.api.base_url}/organizations/${id}`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updateOrganizationData = response.data;
				dispatch({ type: UPDATE_ORGANIZATION_SUCCESS, response: updateOrganizationData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: UPDATE_ORGANIZATION_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const deleteOrganizationApi = (id) => {
	return (dispatch) => {
		dispatch({ type: DELETE_ORGANIZATION });
		axios
			.post(`${config.api.base_url}/organizations/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteOrganizationData = response.data;
				dispatch({ type: DELETE_ORGANIZATION_SUCCESS, response: deleteOrganizationData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: DELETE_ORGANIZATION_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

// Fetch the platform's default project system instruction. Used to
// prefill the "System Instruction" field when creating a new org.
// Super-admin only on the backend; returns 403 otherwise.
export const fetchDefaultSystemInstruction = () => {
  return axios.get(`${config.api.base_url}/organizations/system-instruction/default`, {
    headers: { Authorization: 'Bearer ' + getUserToken() },
  }).then((r) => r.data);
};

export const getOrganizationsDropdownApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_ORGANIZATIONS_DROPDOWN });
		const paramKey = JSON.stringify(data || {});
		dedupedGet(`organizationsDropdown:${paramKey}`, () =>
			axios.get(`${config.api.base_url}/organizations/dropdown`, {
				params: data,
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_ORGANIZATIONS_DROPDOWN_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_ORGANIZATIONS_DROPDOWN_FAIL, response: error.response?.data || error.message }));
	};
};

export const getOrganizationsReset = () => ({
  type: GET_ORGANIZATIONS_RESET,
});

export const getOrganizationByIdReset = () => ({
  type: GET_ORGANIZATION_BY_ID_RESET,
});

export const createOrganizationReset = () => ({
  type: CREATE_ORGANIZATION_RESET,
});

export const updateOrganizationReset = () => ({
  type: UPDATE_ORGANIZATION_RESET,
});

export const deleteOrganizationReset = () => ({
  type: DELETE_ORGANIZATION_RESET,
});

export const getOrganizationsDropdownReset = () => ({
  type: GET_ORGANIZATIONS_DROPDOWN_RESET,
});

